/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:5a299976-8e37-4bee-8426-7244811f89fb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_gGxyRam5f",
    "aws_user_pools_web_client_id": "6dv0kdqfqsskgsbgd309jgoc5s",
    "oauth": {
        "domain": "designsignerauth-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.designsigner.com/,https://qa.designsigner.com/,http://localhost:3000/",
        "redirectSignOut": "https://www.designsigner.com/,https://qa.designsigner.com/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "designsignerfilegen",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
